import React, { useEffect, useState } from "react";
import { Modal, Sheet, ModalClose, Typography, Button, Checkbox, Input } from "@mui/joy";
import { NoteTypeSelect } from "../custom/NoteTypeSelect";
import { create_generate_note } from "../../services/GenerateNote";
import PropTypes from "prop-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { get_user_preference } from "../../services/UserPreferences";
import { useQuery } from "@tanstack/react-query";
import { handleErrorSentry } from "../../utils/constants/Error";

export function AddNoteModal({ open, closePopup, visit_id, visit_title}) {
    const [ note_type, set_note_type ] = useState();
    const [ patientNameDefault, setPatientNameDefault] = useState(true);
    const [ patientName, setPatientName] = useState("");
    const queryClient = useQueryClient();
    const { data: preferences, isLoading, error} = useQuery({
        queryKey: ['preferences'],
        queryFn: () => get_user_preference(),
    })

    const mutate_add_note = useMutation({
        mutationFn: create_generate_note,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['visit', visit_id]})
            queryClient.invalidateQueries({ queryKey: ['visits']})
        },
        onError: (error) => {
            handleErrorSentry(error, "onError");
        }
    })

    const handleSubmit = (event) => {
        event.preventDefault();
        mutate_add_note.mutate({
            visit_id: visit_id,
            note_type: note_type,
            patient_name: patientNameDefault ? visit_title : patientName,
        })
        closePopup();
    }

    useEffect(() => {
        if (preferences) {
            set_note_type(preferences['note_type']);
        }
    }, [preferences])

    return <Modal aria-labelledby="modal-title"
            aria-describedby="modal-desc" open={open} onClose={closePopup} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Sheet variant="outlined"
          sx={{
            maxWidth: 800,
            borderRadius: 'md',
            p: 3,
            boxShadow: 'lg',
            display: "flex",
            flexDirection: "column",
          }}>
            <ModalClose variant="plain" sx={{ m: 1, width: "fit-content" }} />
            <Typography
                component="h2"
                id="modal-title"
                level="h4"
                textColor="inherit"
                fontWeight="lg"
                mb={1}
            >
                Add new note to your visit
            </Typography>
            <Typography id="modal-desc" textColor="text.tertiary" paddingBottom='10px'>
                Choose a new note type to add to your visit!
            </Typography>
            {preferences && <form onSubmit={handleSubmit}>
                <NoteTypeSelect disabled={false} calmTitle={false} noteViews={preferences["note_views"]} value={note_type} 
                sx={{
                    width: "100%",
                    mb: 1
                }}
                onChange={(_, note_given) => {
                    set_note_type(note_given)
                }} required/>
                <Checkbox label="Set patient name as visit name" size="sm" defaultChecked onChange={(event) => { setPatientNameDefault(event.target.checked) }}/>
                {!patientNameDefault && <Input value={patientName} placeholder="Patient Name" size="sm" onChange={(event) => { setPatientName(event.target.value) }} sx={{ py: 1, px: 1, mb: 1}}/>}
                <Button type="submit">CONFIRM</Button>
            </form>}
        </Sheet>
    </Modal>
}


AddNoteModal.propTypes = {
    open: PropTypes.bool.isRequired,
    closePopup: PropTypes.func.isRequired,
    visit_id: PropTypes.string.isRequired,
    reload: PropTypes.func,
}